<template>
  <v-dialog :value="value" persistent scrollable max-width="600">
    <v-card>
      <v-card-title primary-title>
        <h3 class="primary--text">
          {{ $t('Create payment request on Conversion Value of Purchase') }}
        </h3>
        <span class="caption">
          {{
            $t(
              'This payment information will be displayed in the Conversion Value of Purchase section of your Facebook page.'
            )
          }}
        </span>
      </v-card-title>
      <v-card-text style="max-height: 600px">
        <v-layout row wrap>
          <v-flex xs6 pa-1>
            <div class="primary--text caption mb-1">{{ $t('event') }}</div>
            <v-select
              name="eventName"
              v-model="eventName"
              :items="eventNames"
              item-text="label"
              item-value="value"
              v-validate="'required'"
              :data-vv-as="$t('event')"
              @change="value => (eventName = value)"
              hide-details
              outline
            />
            <span class="red--text" style="font-size: 0.9em;" v-if="errors.has('eventName')">{{
              errors.first('eventName')
            }}</span>
          </v-flex>
          <v-flex xs6 pa-1 />
          <v-flex xs6 pa-1>
            <div class="form-control" style="width: 100%;">
              <div class="primary--text caption">{{ $t('Amount') }}</div>
              <input
                name="eventSettingValue"
                ref="amount"
                type="text"
                class="form-control"
                v-model="amount"
                v-validate="'required'"
                :data-vv-as="$t('Amount')"
              />
              <span
                class="red--text"
                style="font-size: 0.9em;"
                v-if="errors.has('eventSettingValue')"
                >{{ errors.first('eventSettingValue') }}</span
              >
            </div>
          </v-flex>
          <v-flex xs6 pa-1>
            <div>
              <div class="primary--text caption">{{ $t('monetary_unit') }}</div>
              <!-- TODO Add *  when event name is Purchase -->
              <v-autocomplete
                name="currencies"
                :items="$store.state.currencies"
                v-model="currency"
                v-validate="{ required: eventName === 'Purchase' }"
                :data-vv-as="$t('monetary_unit')"
                hide-details
                outline
              />
              <span class="red--text" style="font-size: 0.9em;" v-if="errors.has('currencies')">{{
                errors.first('currencies')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" outline @click="onClose()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="onSave()">
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'userID'],
  data() {
    return {
      eventNames: [
        {
          label: 'View Content',
          value: 'ViewContent'
        },
        {
          label: 'Add to Cart',
          value: 'AddToCart'
        },
        {
          label: 'Purchase',
          value: 'Purchase'
        }
      ],
      eventName: 'Purchase',
      amount: '',
      currency: 'THB'
    }
  },
  methods: {
    onClose() {
      this.$validator.reset()
      this.$emit('input', false)
      // this.eventName = ''
      this.amount = ''
      this.currency = 'THB'
    },
    async onSave() {
      const isValid = await this.$validator.validate()

      if (isValid) {
        const pageID = this.selectedBot.pageid

        try {
          this.$store.dispatch('loading')

          const event = {
            event_name: this.eventName,
            value: Number(this.amount),
            currency: this.currency
          }

          await this.post(`page/${pageID}/save-user-event`, {
            userid: this.userID,
            is_save_chat_log: true,
            ...event
          })

          const message = {
            id: new Date().getTime(),
            messagedata: JSON.stringify(event),
            messagetype: 'save_user_event',
            userid: this.userID,
            pageid: pageID,
            answerby: 'bot',
            timestamp: new Date(),
            intent: '{save_user_event}',
            questiondata: '',
            questiontype: '',
            error_data: null,
            message_id: null,
            profile_pic: null,
            first_name: null
          }

          this.$emit('onSave', message)
          this.onClose()
        } finally {
          this.$store.dispatch('loading')
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style scoped>
.v-card__title {
  font-size: 18px;
}

.v-card__actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}
</style>

<style lang="scss">
.v-select__slot {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/FBConversionDialog.vue